import BasePolicy from '@/policies/BasePolicy.js';

export default class AnomalyDetection extends BasePolicy {
    viewAny(user) {
        return user.hasPermissionTo('view an anomaly detection');
    }

    view(user) {
        return user.hasPermissionTo('view an anomaly detection');
    }

    create(user) {
        return user.hasPermissionTo('create an anomaly detection');
    }

    update(user) {
        return user.hasPermissionTo('edit an anomaly detection');
    }

    delete(user) {
        return user.hasPermissionTo('delete an anomaly detection');
    }
}
